import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41385ac2")

_pushScopeId("data-v-41385ac2")
const _hoisted_1 = { class: "qr-code-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "qr-code" }
const _hoisted_4 = { class: "btn-box" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("下载二维码")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_button = _resolveComponent("van-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "item",
        key: item.activityName
      }, [
        _createVNode("div", _hoisted_2, _toDisplayString(item.activityName), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: item.codeUrl,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_van_button, {
            class: "detail-btn",
            type: "primary",
            plain: "",
            round: "",
            color: "#fff",
            onClick: ($event: any) => (
            _ctx.$router.push({
              path: '/huBeiService/serviceList',
              query: {
                activityId: item.activityId,
                salesmanId: _ctx.userId
              }
            })
          )
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_van_button, {
            class: "download-btn",
            type: "primary",
            round: "",
            color: "#ff8c00",
            onClick: ($event: any) => (_ctx.downloadQrcode(item.codeUrl))
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]))
    }), 128))
  ]))
})